export class fdSelectModel {

    public placeholder: string;
    public nombreBotonAccion: string;
    public listaElementos: fdSelectModelList[];
    public listaElementosSeleccionados: fdSelectModelList[];
    public botonGuardar?: string;
    constructor(Placeholder: string, NombreBotonAccion: string
        , ListaElementos: fdSelectModelList[]
        , ListaElementosSeleccionados: fdSelectModelList[], botonGuardar?: string) {

        this.placeholder = Placeholder;
        this.nombreBotonAccion = NombreBotonAccion;
        this.listaElementos = ListaElementos;
        this.listaElementosSeleccionados = ListaElementosSeleccionados;
        this.botonGuardar = botonGuardar;

    }
}

export class fdSelectModelList {

    public nombreElelemento: string;
    public checked: boolean;
    public id?: string
    public objeto?: any;
    constructor(NombreElemento: string, Checked: boolean, Id?: string, objeto?: any) {

        this.nombreElelemento = NombreElemento;
        this.checked = Checked;
        this.id = Id;
        this.objeto = objeto;
    }
}